import BaseApi, { API_BASE_URL, ApiResponse } from './base';
import { JobStatus } from '@/types';

export enum JobAction {
  GUIDE_GENERATION_SYSTEM = 'guideGenerationSystem',
  DETECT_GLOSSARIES = 'detectGlossaries',
}

export enum JobType {
  FROM_PDF = 'fromPdf',
  STEP_GLOSSARY_DETECTION = 'stepGlossaryDetection',
}

export interface Job {
  id: string;
  action: JobAction;
  type: JobType;
  status: JobStatus;
  errorMessage?: string | null;
  payload: any;
  createdAt: string;
  updatedAt: string;
}

class JobsApi extends BaseApi {
  constructor(baseURL: string = API_BASE_URL) {
    super(baseURL);
  }

  async updateJobStatus(id: string, status: JobStatus): Promise<ApiResponse<Job>> {
    return this.put<Job>(`/jobs/${id}/status`, { status });
  }
}

export default new JobsApi();

